import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication, EventType, AuthenticationResult } from '@azure/msal-browser';
import { msalConfig } from './auth/msalConfig';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// MSAL v5 requires initialize() to complete BEFORE any component renders or any
// auth call runs. We do it here, at the very top, and only render the React
// tree once it resolves. Initializing inside an App effect (the earlier
// attempt) left the login popup stuck on the app's own "Loading…" screen
// because the popup rendered React before MSAL could process the response and
// close itself (OS-1683 F4 follow-up).
const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

msalInstance.initialize().then(() => {
  // Set the active account on successful login so downstream silent token
  // acquisition has an account to use.
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult;
      msalInstance.setActiveAccount(payload.account);
    }
  });

  // Redirect login flow: when the app reloads after returning from the Microsoft
  // login redirect, this drains the response from the URL and completes sign-in
  // before we render. (We use redirect, not popup — see msalConfig.ts F4 note.)
  return msalInstance.handleRedirectPromise();
}).then(() => {
  root.render(
    <React.StrictMode>
      <App msalInstance={msalInstance} />
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
